/**
 * URL(liff.state / hash)からクエリを取り出す共通ヘルパー。
 * social.ts の招待コード抽出と analytics.ts の起動コンテキストで同じ解釈を使う。
 */

/** liff.state は二重エンコードされて届くことがあるので、一段だけ追加で復号する。 */
export function decodeLiffState(raw: string): string {
  try {
    return decodeURIComponent(raw)
  } catch {
    return raw
  }
}

/** liff.state("?a=b" または "/path?a=b")のクエリ部分を URLSearchParams にする。 */
export function parseLiffStateQuery(raw: string): URLSearchParams {
  const decoded = decodeLiffState(raw)
  const queryStart = decoded.indexOf('?')
  if (queryStart >= 0) {
    return new URLSearchParams(decoded.slice(queryStart + 1))
  }
  return new URLSearchParams(decoded.startsWith('?') ? decoded.slice(1) : decoded)
}

/** hash("#/path?a=b" または "#a=b")をクエリとして解釈する(hash router 対応)。 */
export function parseHashQuery(hash: string): URLSearchParams {
  if (!hash || hash.length <= 1) return new URLSearchParams()
  const hashQuery = hash.startsWith('#') ? hash.substring(1) : hash
  const qMark = hashQuery.indexOf('?')
  return new URLSearchParams(qMark >= 0 ? hashQuery.substring(qMark + 1) : hashQuery)
}
